import { clearNotificationsCounter } from "../../api/api";
import { NotificationsPage } from '../../pages/Notifications'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/_app/notifications')({
  component: NotificationsPage,
  loader: async () => {
    await clearNotificationsCounter().catch((error) => {
			console.error("Error clearing notifications counter", error);
		});
    return null;
  },
})
